import { Box, Flex, Text } from '@chakra-ui/react'

import { textStyleKeys, textStyles } from '@mangovoice/design-system/textStyles'

import { useReportingI18n } from '../i18n'

interface ShowMoreButtonProps {
  remaining: number
  onClick: () => void
}

export const ShowMoreButton = ({ remaining, onClick }: ShowMoreButtonProps) => {
  const { text } = useReportingI18n()

  return (
    <Flex justifyContent="center" mt="1rem" mb="1.5rem">
      <Flex
        as="button"
        align="center"
        gap="0.5rem"
        px="1rem"
        py="0.5rem"
        bg="transparent"
        color="fg.muted"
        {...textStyles[textStyleKeys.Body3]}
        cursor="pointer"
        transition="all 0.2s"
        _hover={{ color: 'fg.default' }}
        onClick={onClick}
      >
        <Text>
          {text(
            'extensionComparisonChart.showMore',
            'Show More ({{remaining}} remaining)',
            { remaining },
          )}
        </Text>
        <Box
          w="14px"
          h="14px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          ▾
        </Box>
      </Flex>
    </Flex>
  )
}
